
export default function CTASection() {
  const handleContactClick = () => {
    window.location.href = '/contact';
  };

  return (
    <section className="py-20 bg-teal-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Ready to Transform Your Supply Chain?
        </h2>
        <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
          Let's discuss how XJ Global can help optimize your sourcing, reduce costs, and improve your product quality. Your first consultation is free.
        </p>
        <div className="flex justify-center">
          <button
            onClick={handleContactClick}
            className="inline-flex items-center px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Contact Us
            <div className="ml-2 w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-line"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
